import type { RequestFunction } from "@kanda-libs/openapi-io-ts-runtime";
import * as parameters from "../components/parameters";
import * as schemas from "../components/schemas";

export type PostMeRequestParameters = {
  x_kanda_protected: "yes" | "no";
};

export const postMeOperation = {
  path: "/api/me",
  method: "post",
  responses: {
    "200": { _tag: "JsonResponse", decoder: schemas.AuthUser },
    default: { _tag: "JsonResponse", decoder: schemas.Error },
  },
  parameters: [parameters.x_kanda_protected],
  requestDefaultHeaders: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  body: {
    _tag: "JsonBody",
  },
} as const;

export type PostMeRequestFunction = RequestFunction<
  { params: PostMeRequestParameters; body: schemas.InfoMe },
  schemas.AuthUser
>;
